import { SportsMenuTabListCombinedProps } from './types';

const usePresenter = (props: SportsMenuTabListCombinedProps): SportsMenuTabListCombinedProps => {
  return props;
};

export default usePresenter;
